/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "visibilityOff",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#666666"
            },
            "visibilityOff": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "15",
            "height": "12"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 12", className: "visibilityOff", width: this.props.width, height: this.props.height },
            _react2["default"].createElement("path", { className: "st0", d: "M2.6 8.7l1.9-2v-.4c0-1.7 1.4-3.1 3.1-3.1h.2l.9-1c-.3-.1-.7-.1-1-.1C3.1 2.1 0 6.3 0 6.3s1 1.3 2.6 2.4zM10.9 2.9c.5-.6 1-1.1 1.6-1.7.6-.7-.4-1.7-1-1L1.7 10.7c-.6.7.4 1.7 1 1s1.2-1.3 1.8-2c.9.4 1.9.6 3 .6 4.4 0 7.5-4.1 7.5-4.1s-1.6-2.1-4.1-3.3zM7.5 9.4c-.7 0-1.4-.3-1.9-.7.3-.3.5-.6.8-.9.3.2.7.4 1.2.4 1.1 0 1.9-.9 1.9-1.9 0-.5-.2-1-.5-1.3.3-.3.5-.6.8-.9.5.6.9 1.3.9 2.1-.1 1.8-1.5 3.2-3.2 3.2z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/visibilityOff.js